(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hg-v12-header-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    if (!document.querySelector('[data-hg-home-light]') || document.documentElement.dataset.hgLogoIgnition) return;
    const logo = document.querySelector('.hg-v12-native-header .header__heading-link');
    if (!logo) return;
    document.documentElement.dataset.hgLogoIgnition = 'ready';
    const image = logo.querySelector('img');
    const finish = () => logo.classList.remove('hg-home-logo-starting');
    const start = () => {
      logo.classList.add('hg-home-logo-starting');
      document.documentElement.dataset.hgLogoIgnition = 'playing';
      logo.addEventListener('animationend', () => { finish(); document.documentElement.dataset.hgLogoIgnition = 'complete'; }, {once:true});
    };
    window.addEventListener('pagehide', finish, {once:true});
    if (image && !image.complete) image.addEventListener('load', start, {once:true});
    else start();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
